import type { TravelAgencyTour } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';
import imageLoader from '../../loader';

type TourPhoto = NonNullable<TravelAgencyTour['image']>;

/** The tour API currently mixes MOV uploads into its images collection. */
export function getTourPhotos(tour: Pick<TravelAgencyTour, 'image' | 'images'>): TourPhoto[] {
  return [tour.image, ...(Array.isArray(tour.images) ? tour.images : [])].filter(
    (image): image is TourPhoto => {
      if (!image || typeof image.url !== 'string' || !image.url.trim()) return false;
      try {
        const url = new URL(image.url, 'https://objavujsvet.sk');
        return (
          ['http:', 'https:'].includes(url.protocol) &&
          !/\.(?:mov|mp4|m4v|webm|avi|mkv)$/i.test(url.pathname)
        );
      } catch {
        return false;
      }
    },
  );
}

/** Use the same image service as the thumbnails: browsers cannot decode original HEIC. */
export function toTourLightboxImages(images: TourPhoto[]) {
  return images.map(image => ({
    ...image,
    url: imageLoader({ src: image.url, width: 1920, quality: 90 }),
  }));
}
